import type { FC } from 'react'

import { useAppContext } from '@/App.context'
import Page from '@/components/content/Page'
import Button from '@/components/form/Button'
import { WHITE_LABELS } from '@/consts'

const WhitelabelPage: FC = () => {
  const { whiteLabel: selectedWhiteLabel, setWhiteLabel } = useAppContext()

  return (
    <Page>
      <h1>Whitelabels</h1>

      {WHITE_LABELS.map(whiteLabel => (
        <Button
          key={whiteLabel}
          selected={selectedWhiteLabel === whiteLabel}
          style={{ margin: '.5rem' }}
          onClick={() => setWhiteLabel(whiteLabel)}
        >
          {whiteLabel}
        </Button>
      ))}
    </Page>
  )
}

export default WhitelabelPage
